import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PoolService } from "src/app/services/pool.service";
// import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-manual-movement-dialog",
  templateUrl: "./manual-movement-dialog.component.html",
  styleUrls: ["./manual-movement-dialog.component.scss"],
})
export class ManualMovementDialogComponent {
  direction: number = 1;
  selectedTime: string = "";
  loading: boolean = false;
  logsLoading: boolean = false;

  // Personelin o günkü ham donanım logları
  rawCardLogs: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ManualMovementDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      employeeId: number;
      fullName: string;
      date: string;
      companyId: number;
    },
    // private http: HttpClient,
    private poolService: PoolService,
  ) {
    // Seçilen günün tarihini saat inputu için başlangıç olarak ayarla
    const formattedDate = new Date(data.date).toISOString().split("T")[0];
    this.selectedTime = `${formattedDate}T09:00`; // Varsayılan sabah 09:00
  }

  ngOnInit(): void {
    this.loadEmployeeDailyLogs();
  }

  // Modalı açınca personelin o günkü gerçek turnike geçmişini listeler
  loadEmployeeDailyLogs(): void {
    this.logsLoading = true;

    this.poolService
      .dailyLogs(this.data.employeeId.toString(), this.data.date)
      .subscribe({
        next: (res) => {
          this.rawCardLogs = res;
          this.logsLoading = false;
        },
        error: () => (this.logsLoading = false),
      });
  }

  selectLogTime(log: any): void {
    // 1. Cihaz ID'sine göre yön tahmini yap (Tek ise Giriş (1), Çift ise Çıkış (2))
    this.direction = log.device % 2 !== 0 ? 1 : 2;

    // 2. Gelen masterTime tarihini datetime-local inputunun anlayacağı formatta (YYYY-MM-DDTHH:mm) eşitle
    const dateObj = new Date(log.masterTime);

    // Timezone kaymasını önleyerek lokal ISO string üretme
    const tzOffset = dateObj.getTimezoneOffset() * 60000;
    const localISOTime = new Date(dateObj.getTime() - tzOffset)
      .toISOString()
      .slice(0, 16);

    this.selectedTime = localISOTime;
  }

  save(): void {
    this.loading = true;
    const payload = {
      companyId: this.data.companyId,
      employeeId: this.data.employeeId,
      direction: this.direction,
      timestamp: new Date(this.selectedTime).toISOString(),
    };

    this.poolService.addManual(payload).subscribe({
      next: (data) => {
        this.loading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
      },
    });
  }
}
